import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { guideSteps } from "@/mocks/guide";

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="观前指南"
            title="新观众可以这样入门"
            desc="如果你是第一次接触这部作品，下面四步能帮你避开常见的「看不下去」的坑，用更舒服的节奏进入故事。"
          />
        </Reveal>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((step, index) => (
            <Reveal key={step.id} delay={(index % 4) * 80}>
              <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {index + 1}
                  </span>
                  <span className="text-xs font-medium tracking-wide text-primary-700">{step.step}</span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-7 text-foreground-700">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}